import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { removeCartItem } from '../../Redux/features/Cart/CartSlice'
import "../../Styles/AutoComplete.css"
import { formatSlug } from '../../Utils/Helper'
import Swal from 'sweetalert2';

const HeaderMiddle = () => {

    const cartList = useSelector(state => state.Cart)
    const wishList = useSelector(state => state.Wishlist)
    const dispatch = useDispatch()
    const suggestionTimeoutRef = useRef(null);
    const [subTotalAmount, setSubTotalAmount] = useState(0)
    const [category_id, setcategory_id] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState('')
    const [suggestionList, setSuggestionList] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false);
    const { apiURL } = useContext(ConfigContext)
    const [data, setData] = useState([]);
    const navigate = useNavigate()
    const token = localStorage.getItem("token");
    const path = useLocation();

    const GetProductSearchList = async () => {
        try {
            const response = await axios.get(`${apiURL}Home/GetProductSearchList`, { params: { category_id: category_id } });

            if (response.data.success) {
                setData(response.data.data);
                setSuggestionList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const handleProductDetails = (item) => {

        if (item) {
            const currentPath = path.pathname.includes("GetProductDetails");
            const newPath = currentPath
                ? `/ProductDetails/${formatSlug(item.product_title)}=${item.product_id}`
                : `/GetProductDetails/${formatSlug(item.product_title)}=${item.product_id}`;

            if (path.pathname !== newPath) {
                navigate(newPath);
            }
        }
    };

    const calculatesubTotalAmount = () => {
        const subTotal = cartList.reduce((acc, cur) => acc + cur.quantity * cur.product_variant_sale_price, 0)
        setSubTotalAmount(subTotal)
    }

    const handleSearchCategories = (value) => {

        setSearchInputValue(value);
        if (value.length > 0) {
            const filteredData = data.filter((item) =>
                item.product_title.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestionList(filteredData);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (product) => {
        setSearchInputValue(product.product_title);
        setShowSuggestions(false);

        if (product) {
            const currentPath = path.pathname.includes("GetProductDetails");
            const newPath = currentPath
                ? `/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`
                : `/GetProductDetails/${formatSlug(product.product_title)}=${product.product_id}`;
            if (path.pathname !== newPath) {
                navigate(newPath);
            }
        }
    };


    const handleBlur = () => {
        suggestionTimeoutRef.current = setTimeout(() => {
            setShowSuggestions(false);
        }, 200);
    };

    const handleFocus = () => {
        clearTimeout(suggestionTimeoutRef.current);
    };

    useEffect(() => {
        GetProductSearchList();
    }, [category_id]);

    useEffect(() => {
        calculatesubTotalAmount()
    }, [cartList]);

    const handleLogout = () => {
        localStorage.removeItem("customer_id");
        localStorage.removeItem("token")
        navigate('/')
    }

    const handleLogoutConfirmation = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, log me out!",
        }).then((result) => {
            if (result.isConfirmed) {
                handleLogout();
            }
        });
    };

    return (
        <>
            <div className="container">
                <div className="header-wrap">
                    <div className="w-25 d-flex justify-content-center align-items-center">
                        <Link to="/"><img src="/assets/imgs/logo/2.png" alt="logo" width={400} /></Link>
                    </div>
                    <div className="header-right flex items-center space-x-0">
                        <div className="search-style-2">
                            <form action="#">
                                <input
                                    type="text"
                                    value={searchInputValue}
                                    onChange={(e) => handleSearchCategories(e.target.value)}
                                    placeholder='Search for product...'
                                    onBlur={handleBlur}
                                    onFocus={handleFocus}
                                    aria-autocomplete="list"
                                    aria-controls="autocomplete-list"
                                    style={{ border: "2px", height: "53px" }}
                                />
                            </form>
                            {
                                showSuggestions && (
                                    <div id="autocomplete-list" className="suggestions"
                                        style={{ width: "60%", left: "20%" }}
                                        onMouseDown={(e) => e.preventDefault()}>
                                        {suggestionList.length ?
                                            (suggestionList.map((item, i) => (
                                                <div
                                                    key={i}
                                                    onMouseDown={() => handleSuggestionClick(item)}
                                                    role="option">
                                                    {item.product_title}
                                                </div>
                                            ))
                                            ) : (<div>No suggestions found</div>)
                                        }
                                    </div>
                                )}
                        </div>
                        <div className="header-action-right">
                            <div className="header-action-2">
                                <div className="header-action-icon-2">
                                    <Link to="/WishList">
                                        <img className="svgInject" alt="Nest" src="/assets/imgs/theme/icons/icon-heart.svg" />
                                        <span className="pro-count blue">{wishList.length}</span>
                                    </Link>
                                    <Link to="/WishList">
                                        <span className="lable">Wishlist</span>
                                    </Link>
                                </div>
                                <div className="header-action-icon-2">
                                    <Link className="mini-cart-icon" to="/AddToCart">
                                        <img alt="Nest" src="/assets/imgs/theme/icons/icon-cart.svg" />
                                        <span className="pro-count blue">{cartList.length}</span>
                                    </Link>
                                    <Link to="/AddToCart">
                                        <span className="lable">Cart</span>
                                    </Link>
                                    <div className="cart-dropdown-wrap cart-dropdown-hm2">
                                        {
                                            cartList.length !== 0 ?
                                                <ul>
                                                    {
                                                        cartList.map((item) => (
                                                            <li key={item.product_variant_id}>
                                                                <div className="shopping-cart-img">
                                                                    <a>
                                                                        <img src={item.product_image_url} />
                                                                    </a>
                                                                </div>
                                                                <div className="shopping-cart-title">
                                                                    <h4>
                                                                        <a onClick={() => handleProductDetails(item)}>{item.product_title}</a>
                                                                    </h4>
                                                                    <h4>
                                                                        <span>{item.quantity} × </span>
                                                                        ₹ {item.product_variant_sale_price}
                                                                    </h4>
                                                                </div>
                                                                <div
                                                                    className="shopping-cart-delete"
                                                                >
                                                                    <span
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => dispatch(removeCartItem(item.product_variant_id))}
                                                                    >
                                                                        <i className="fi-rs-cross-small" />
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                                :
                                                <p>Cart Is Empty</p>
                                        }
                                        <div className="shopping-cart-footer">
                                            <div className="shopping-cart-total">
                                                <h4>Total <span>₹{subTotalAmount}</span></h4>
                                            </div>
                                            <div className="shopping-cart-button">
                                                <Link to="/AddToCart" className="outline">View cart</Link>
                                                {
                                                    token
                                                        ?
                                                        cartList.length === 0 ?
                                                            <button disabled={cartList.length == 0} className='btn btn-sm'>Checkout</button>
                                                            :
                                                            <Link to="/Checkout">Checkout</Link>
                                                        :
                                                        <Link
                                                            to="/Login"
                                                        >
                                                            <i className="fi fi-rs-sign-out mr-10" />
                                                            Log In
                                                        </Link>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="header-action-icon-2">
                                    <Link to="/MyAccount">
                                        <img
                                            className="svgInject"
                                            alt="Nest"
                                            src="/assets/imgs/theme/icons/icon-user.svg"
                                        />
                                    </Link>
                                    <Link to="/MyAccount"><span className="lable ml-0">Account</span></Link>
                                    <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                                        <ul>
                                            {
                                                token
                                                    ?
                                                    <>
                                                        <li>
                                                            <Link to="/MyAccount"><i className="fi fi-rs-user mr-10" />My Account</Link>
                                                        </li>
                                                        <li>
                                                            <Link Link to="/MyOrders"><i className="fi fi-rs-label mr-10" />My Orders</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/WishList"><i className="fi fi-rs-heart mr-10" />My Wishlist</Link>
                                                        </li>
                                                    </>
                                                    :
                                                    <li>
                                                        <Link to="/Login" ><i className="fi fi-rs-sign-out mr-10" />Log In</Link>
                                                    </li>
                                            }
                                            {token && (
                                                <li>
                                                    <Link to="/Login" onClick={(e) => { e.preventDefault(); handleLogoutConfirmation(); }}>
                                                        <i className="fi fi-rs-sign-out mr-10" /> Log Out
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="header-action-right">
                            <div className="header-action-2">
                                <div className="header-action-icon-2">
                                    <a href="shop-wishlist.html">
                                        <img className="svgInject" alt="Nest" src="assets/imgs/theme/icons/icon-heart.svg" />
                                        <span className="pro-count blue">6</span>
                                    </a>
                                    <a href="shop-wishlist.html"><span className="lable">Wishlist</span></a>
                                </div>
                                <div className="header-action-icon-2">
                                    <a className="mini-cart-icon" href="shop-cart.html">
                                        <img alt="Nest" src="assets/imgs/theme/icons/icon-cart.svg" />
                                        <span className="pro-count blue">2</span>
                                    </a>
                                    <a href="shop-cart.html"><span className="lable">Cart</span></a>
                                    <div className="cart-dropdown-wrap cart-dropdown-hm2">
                                        <ul>
                                            <li>
                                                <div className="shopping-cart-img">
                                                    <a href="shop-product-right.html"><img alt="Nest" src="assets/imgs/shop/thumbnail-3.jpg" /></a>
                                                </div>
                                                <div className="shopping-cart-title">
                                                    <h4><a href="shop-product-right.html">Daisy Casual Bag</a></h4>
                                                    <h4><span>1 × </span>$800.00</h4>
                                                </div>
                                                <div className="shopping-cart-delete">
                                                    <a href="#"><i className="fi-rs-cross-small" /></a>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="shopping-cart-img">
                                                    <a href="shop-product-right.html"><img alt="Nest" src="assets/imgs/shop/thumbnail-2.jpg" /></a>
                                                </div>
                                                <div className="shopping-cart-title">
                                                    <h4><a href="shop-product-right.html">Corduroy Shirts</a></h4>
                                                    <h4><span>1 × </span>$3200.00</h4>
                                                </div>
                                                <div className="shopping-cart-delete">
                                                    <a href="#"><i className="fi-rs-cross-small" /></a>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="shopping-cart-footer">
                                            <div className="shopping-cart-total">
                                                <h4>Total <span>$4000.00</span></h4>
                                            </div>
                                            <div className="shopping-cart-button">
                                                <a href="shop-cart.html" className="outline">View cart</a>
                                                <a href="shop-checkout.html">Checkout</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="header-action-icon-2">
                                    <a href="page-account.html">
                                        <img className="svgInject" alt="Nest" src="assets/imgs/theme/icons/icon-user.svg" />
                                    </a>
                                    <a href="page-account.html"><span className="lable ml-0">Account</span></a>
                                    <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                                        <ul>
                                            <li>
                                                <a href="page-account.html"><i className="fi fi-rs-user mr-10" />My Account</a>
                                            </li>
                                            <li>
                                                <a href="page-account.html"><i className="fi fi-rs-location-alt mr-10" />Order Tracking</a>
                                            </li>
                                            <li>
                                                <a href="page-account.html"><i className="fi fi-rs-label mr-10" />My Voucher</a>
                                            </li>
                                            <li>
                                                <a href="shop-wishlist.html"><i className="fi fi-rs-heart mr-10" />My Wishlist</a>
                                            </li>
                                            <li>
                                                <a href="page-account.html"><i className="fi fi-rs-settings-sliders mr-10" />Setting</a>
                                            </li>
                                            <li>
                                                <a href="page-login.html"><i className="fi fi-rs-sign-out mr-10" />Sign out</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                </div >
            </div >
        </>
    )
}

export default HeaderMiddle